import React from 'react';
import { ApolloProvider, Query } from 'react-apollo';
import gql from 'graphql-tag';
import { SnackbarProvider } from 'notistack';
import JssProvider from 'react-jss/lib/JssProvider';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import { create } from 'jss';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import client from '../lib/apolloClient';
import themes from '../lib/themes';
import QuickNotes from '../components/QuickNotes/QuickNotes';

// GraphQL query to get Quick Notes with filtering data
const GET_QUICK_NOTES_DATA = gql`
  query GetQuickNotesData {
    getActivityTypes {
      id
      name
    }
    getQuickNoteCategories {
      id
      name
      description
    }
    getQuickNoteAuthors {
      id
      name
      allowed_name
    }
    getCurrentUser {
      id
      name
      is_admin
    }
  }
`;

// Simple loading spinner component
const SimpleLoadingSpinner = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
    <CircularProgress />
  </div>
);

const QuickNotesContainer = (props, railsContext) => {
  const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: true,
    productionPrefix: 'fbQuickNotes',
  });
  
  const jss = create({
    ...jssPreset(),
  });
  
  const theme = themes[railsContext?.theme_name] || themes.findBobTheme;
  window.locale = railsContext?.i18nLocale || 'en';

  return (
    <JssProvider jss={jss} generateClassName={generateClassName} classNamePrefix="fbQuickNotes-">
      <MuiThemeProvider theme={createMuiTheme(theme)}>
        <CssBaseline />
        <SnackbarProvider maxSnack={3}>
          <ApolloProvider client={client}>
            <Query query={GET_QUICK_NOTES_DATA}>
              {({ loading, error, data }) => {
                if (loading) return <SimpleLoadingSpinner />;
                if (error) return <div>Error loading Quick Notes data: {error.message}</div>;
                
                return (
                  <QuickNotes 
                    activityTypes={data?.getActivityTypes || []}
                    categories={data?.getQuickNoteCategories || []}
                    authors={data?.getQuickNoteAuthors || []}
                    currentUser={data?.getCurrentUser}
                    {...props}
                  />
                );
              }}
            </Query>
          </ApolloProvider>
        </SnackbarProvider>
      </MuiThemeProvider>
    </JssProvider>
  );
};

export default QuickNotesContainer; 